class Popover extends HTMLElement {
    constructor() {
        super();

        this.bindEvents = this.bindEvents.bind(this);
        this.togglePopover = this.togglePopover.bind(this);
    }

    connectedCallback() {
        // Get the button and the popover content elements
        this.popoverButton = this.querySelector('.js-popover-button');
        this.popoverContent = this.querySelector('.js-popover-content');

        // Media Queries
        this.isMobile = window.matchMedia(`(max-width: ${this.mobileBreakpoint}px)`).matches;

        if (this.popoverButton && this.popoverContent && !this.isMobile) {
            this.bindEvents();
        }
    }

    bindEvents() {
        // Add an event listener to the button to toggle the popover when clicked
        this.popoverButton.addEventListener('click', this.togglePopover);
        
        // Add an event listener to the document to hide the popover content when clicked outside the button
        document.addEventListener('click', (event) => {
          if (event.target !== this && !this.contains(event.target)) {
            this.classList.remove('visible');
          }
        });
    }

    // Function to toggle the visibility of the popover content
    togglePopover() {
        this.classList.toggle('visible');
    }
}

customElements.define('w3-popover', Popover);
